import { t } from '@lingui/core/macro';
import { Alert, Box, LoaderOverlay } from '@pocketlaw/tetris';
import { useDocumentApproversWithStatus } from 'app/domains/approval/hooks/useDocumentApproversWithStatus';
import { useCompanyFeatures } from 'app/domains/companies';
import { useMatchWorkflowsForDocument } from 'app/domains/workflows/features/useMatchWorkflowsForDocument';
import { ApprovalType, WorkflowType } from 'shared/domains/apollo/generated/types';
import { ApprovalApproved } from './ApprovalApproved';
import { ApprovalPending } from './ApprovalPending';
import { RequestAll } from './RequestAll';
import { RequestOneOf } from './RequestOneOf';
import { RequestVoluntary } from './RequestVoluntary';
import { RequestVoluntaryAdvanced } from './RequestVoluntaryAdvanced';
import { useApprovalWorkflow } from '../../ApprovalWorkflowProvider';
export function Approvers() {
    const { approvalPending, approvalType, approvalApproved, documentId } = useApprovalWorkflow();
    const { approvers, loading } = useDocumentApproversWithStatus();
    const { isFeatureAvailable } = useCompanyFeatures();
    const isAdvancedWorkflowsAvailable = isFeatureAvailable('document-assistant:workflows');
    const { matchedWorkflows, loading: loadingWorkflows, error, } = useMatchWorkflowsForDocument(documentId, [WorkflowType.ApprovalRequirementCheck]);
    const renderAdvanced = isAdvancedWorkflowsAvailable && matchedWorkflows.length > 0;
    if (loading || loadingWorkflows) {
        return (<Box height="100%">
        <LoaderOverlay label={t({
                comment: 'Approval sidebar - Loading approvers label',
                message: 'Loading approvers...',
            })}/>
      </Box>);
    }
    if (error) {
        return (<Alert appearance="danger" message={t({
                message: 'Something went wrong, please reload the page and try again',
                comment: 'Document approval check - workflow matching error',
            })}/>);
    }
    if (approvalApproved) {
        return <ApprovalApproved approvers={approvers}/>;
    }
    if (approvalPending) {
        return <ApprovalPending approvers={approvers}/>;
    }
    if (!approvalType) {
        return renderAdvanced ? <RequestVoluntaryAdvanced workflows={matchedWorkflows}/> : <RequestVoluntary />;
    }
    if (approvalType === ApprovalType.All) {
        return <RequestAll approvers={approvers}/>;
    }
    return <RequestOneOf approvers={approvers}/>;
}
